import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
    IonIcon,
    IonRow,
    IonCol,
    IonText,
    IonGrid,
    IonButton,
    IonPage,
    IonContent,
    IonItemDivider,
    IonLoading,
    IonCard,
    IonImg,
    useIonAlert,
    IonLabel,
    IonInput,
    IonCardHeader,
    IonCardContent,
    IonList,
    IonItem,
    IonCardTitle,
    IonBadge,
    IonChip,
    IonNote,
    IonAvatar,
    IonListHeader,
    IonSearchbar,
    IonSelect,
    IonSelectOption

} from "@ionic/react";
import Authservice from "../Services/user.service";
import { calendar, checkmarkCircleSharp, close, createOutline, location, logoWhatsapp, person, shareOutline, star, trashBin, trashOutline, warning } from "ionicons/icons";
import UserHead from "./UserHead";
import Foot from "./Foot";
import { Modal, ModalHeader } from "react-bootstrap";
import "./Bookdetails.css";
import moment from "moment";
import useRazorpay from "react-razorpay";
import { Capacitor } from "@capacitor/core";
import { useHistory } from "react-router";
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import SessionTimeout from "../Services/SessionTimeOut";
import "./Myorder.css"
import HeadFoot from "./Head";
import { edit_icon, imagePathForRecipt, tick } from "../theme/imagePath";
import UserService from "../Services/auth.service";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../Services/firebase-config";
import validator from 'validator'
import { AppContext } from "../components/AppContext";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import CommonDataTable from "../components/datatable";
import CommonModal from "../components/popipInfo";
import Lightbox from "react-image-lightbox";
import DataTable from "react-data-table-component";
import customTableStyle from "../components/CustomTableStyle";
import CustomPaginationArrows from "../components/CustomPaginationArrows";
import { chevronBack, chevronForward } from 'ionicons/icons';


const UserBookingOrders: React.FC = () => {
    const [token, settoken]: any = useState(sessionStorage.getItem("token"));
    const [payData, setPayData]: any = useState([])
    const [cartList, setcart]: any = useState([]);
    const [paymentdata, setPaymentdata]: any = useState([]);
    const Razorpay = useRazorpay();
    const [showLoading, setShowLoading] = useState(false);
    const [Alert] = useIonAlert()
    const [userAddress, setUserAddress]: any = useState(sessionStorage.getItem("Address"));

    const { userid } = useContext(AppContext)!;

    const isMobile = window.innerWidth <= 768;
    const [Commonmodal, setCommonmodal] = useState(false)
    const [CommonModalMesg, setCommonModalMesg] = useState("")
    const [Commmonmodaltitle, setCommonmodaltitle] = useState("")
    const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
    const [showlightBox, setShowLightBox] = useState(false);
    const [image, setImage] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);


    const totalPages = Math.ceil(cartList.length / rowsPerPage);

    const [bookingStatusMap, setBookingStatusMap] = useState<{ [key: string]: string }>({});
    const [filterTextDate, setFilterTextDate] = useState("")

    const headerColumns = [
        {
            name: 'Order',
            selector: (row: any) => row.orderNo,
            sortable: true,
            width: "130px"
        },
        {
            name: 'Date',
            selector: (row: any) => row.orderDate,
            sortable: true,
            format: (row: any) => new Date(row.orderDate).toLocaleDateString(),
            width: "120px"
        },
        {
            name: "Pooja Name",
            selector: (row: any) => row.bookingDetailsDtos?.[0]?.poojaName ?? "",
            sortable: true,
            width: "200px"
        },
        {
            name: "Temple Name",
            selector: (row: any) => row.templeName,
            sortable: true,
        },
        {
            name: "Temple Admin",
            selector: (row: any) => row.templeAdmin,
            sortable: true,
        },
        {
            name: "Ordered By",
            selector: (row: any) => row.orderedBy,
            sortable: true,
        },
        {
            name: 'Amount',
            selector: (row: any) => row.totalAmount,
            sortable: true,
            format: (row: any) => `₹${row.totalAmount}`,
        },
        {
            name: 'Status',
            selector: (row: any) => row.bookingStatus,
            sortable: true,
            format: (row: any) => bookingStatusMap[row.bookingStatus],
        }
    ];

    const dateTableData = cartList.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterTextDate.toLowerCase()) !== -1
    );

    const proceedPayment = (tkn: any) => {
        if (cartList.length == 0) {
            setShowLoading(false);
            Alert('your cart is empty')
            return;
        }
        console.log(payData, "jksdbfdjkb")
        var obj = { "userCartDetailDtoLst": payData }
        console.log(paymentdata)
        Authservice.payInit(tkn, obj).then((response: any) => {
            console.log(response.data)
            if (response.data.errors !== null) {
                Alert(response.data.errors)
            }
            else if (response.data.initResMsg !== null) {
                Alert(response.data.initResMsg)
            }
            else {
                var options: any = {
                    key: response.data.pgOption.key,
                    key_secret: response.data.secretKey,
                    amount: response.data.pgOption.amount,
                    currency: response.data.pgOption.currency,
                    name: response.data.pgOption.name,
                    order_id: response.data.pgOption.order_id,
                    description: response.data.pgOption.description,
                    modal: {
                        escape: false, ondismiss: function () {
                            Alert("Payment Failed")
                        }
                    },
                    handler: function (res: any) {
                        var resData: any = {
                            "amount": response.data.pgOption.amount,
                            "orderId": res.razorpay_order_id,
                            "cartPayRefId": response.data.cartPayRefId,
                            "signature": res.razorpay_signature,
                            "paymentId": res.razorpay_payment_id
                        }
                        console.log("resData", resData);
                        Authservice.payOfferingRes(token, resData)
                            .then((response) => {
                                console.log("payresponse" + response);
                                Alert({
                                    header: "Atmagram",
                                    message: "Order placed successfully, Please visit My Offerings",
                                    backdropDismiss: false,
                                    buttons: [
                                        {
                                            text: "ok",
                                            handler: () => {
                                                window.location.reload()
                                            }
                                        }
                                    ]
                                })
                            })
                            .catch((error) => {
                                Alert("Something went wrong, please try again later.");
                            });
                    },
                    prefill: {
                        name: response.data.pgOption.name,
                        email: response.data.email,
                        contact: response.data.contact
                    },
                    theme: {
                        color: response.data.theme
                    }
                };
                var pay: any = new Razorpay(options)
                pay.on("payment.failed", function (data: any) {
                    Alert(data.error.reason);
                });
                setShowLoading(false);
                pay.open()
            }
        })
    }

    const setPaymentData = (list: any, tkn: any) => {
        for (let order of list) {
            let user: any;
            if (order.userModel == null) {
                user = userAddress
            } else {
                user = order.userModel.id;
            }
            var data = {
                "id": order.id,
                "userModel": {
                    "id": user
                },
                "poojaOfferings": {
                    "id": order.poojaOfferings.id,
                    "price": order.poojaOfferings.price
                },
                "firstName": order.firstName,
                "mailId": order.mailId,
                "mobileNumber": order.mobileNumber,
                "deliveryAddress": order.deliveryAddress,
                "prasadhamDelFlag": order.prasadhamDelFlag,
                "fromDate": order.fromDate,
                "toDate": order.toDate,
                "payDakshinaToPriestFlag": order.payDakshinaToPriestFlag,
                "payDakshinaToTempleFlag": order.payDakshinaToTempleFlag,
                "dakshinaAmountForPriest": order.dakshinaAmountForPriest,
                "dakshinaAmountToTemple": order.dakshinaAmountToTemple,
                "delFlag": order.delFlag,
                "noOfMonths": order.noOfMonths
            }
            console.log(data)
            payData.push(data)
        }
        setTimeout(() => {
            proceedPayment(tkn);
        }, 3000);
    }

    const Cart = (page = 0, size = 10) => {
        setShowLoading(true);

    if (!token || !userid || page === null || page === undefined || size === null || size === undefined) {
    console.error('Invalid parameters:', { token, userid, page, size });
    window.location.reload();
    throw new Error('Required parameters are missing or invalid');
  }

        Authservice.getuserbookingOrders(token, userid, page, size)
            .then((response: any) => {
                console.log("API Response:", response.data);

                if (response.data.content) {
                    setcart(response.data.content);
                    setTotalRows(response.data.totalItems || 0);
                } else {
                    setcart(response.data);
                    setTotalRows(response.data.length || 0);
                }
                setShowLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching orders:", error);
                setcart([]);
                setShowLoading(false);
            });

        Authservice.getBookingStatus(token, userid)
            .then((response: any) => {
                console.log("Status response:", response.data);
                const statusMap = response.data.reduce((acc: any, item: any) => {
                    acc[item.StatusId] = item.Status;
                    return acc;
                }, {} as { [key: string]: string });
                setBookingStatusMap(statusMap);
            })
            .catch((error) => {
                console.error("Error fetching status:", error);
            });
    };

    // Fixed pagination handlers
    const handlePageChange = (page: number) => {
        console.log("Page changed to:", page);
        setCurrentPage(page - 1);
        Cart(page - 1, rowsPerPage);
    };

    const handleRowsPerPageChange = (newRowsPerPage: number, page: number) => {
        console.log("Rows per page changed:", newRowsPerPage, "Page:", page);
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(page - 1);
        Cart(page - 1, newRowsPerPage);
    };


    useEffect(() => {
        setShowLoading(true)
        Cart();
    }, [])

    const handleRowClicks = (row: any) => {
        console.log(row)
        setExpandedRows((prev: any) => ({
            ...prev,
            [row.id]: !prev[row.id],
        }));
    };

    const formatDate = (timestamp: any, num: any) => {
        if (num == "1") {
            return new Date(timestamp).toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
        } else {
            return new Date(timestamp).toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'long',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
    };

    const OrderDetailsCard = ({ data: order }: any) => {
        console.log(order, "order")
        const formatDate = (timestamp: any) => {
            return new Date(timestamp).toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            });
        };

        const tantriCharges = order.bookingDetailsDtos
            .filter((booking: any) => booking.poojaCode === "TANTRI")
            .reduce((sum: number, booking: any) => sum + booking.poojaAmount, 0);
        const poojari = order.bookingDetailsDtos
            .filter((booking: any) => booking.poojaCode === "SWAMI")
            .reduce((sum: number, booking: any) => sum + booking.poojaAmount, 0);

        const templeDonation = order.bookingDetailsDtos
            .filter((booking: any) => booking.poojaCode === "TEMPLE")
            .reduce((sum: number, booking: any) => sum + booking.poojaAmount, 0);

        return (
            <div className="p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Pooja Details Card */}
                    <IonCard>
                        <IonCardHeader>
                            <IonCardTitle>Pooja Details</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <div className="space-y-4">
                                {order.bookingDetailsDtos
                                    .filter((booking: any) => !['VDC', 'DLVR', 'TANTRI', 'SWAMI', 'TEMPLE'].includes(booking.poojaCode))
                                    .map((booking: any) => (
                                        <div key={booking.id} className="border-b pb-3">
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <div className="flex justify-between items-start">
                                                    <div className="flex gap-3">
                                                        <div>
                                                            <div>
                                                                <p className="font-medium">{booking.name || `Pooja ${booking.poojaCode}`}</p>
                                                                <p className="text-sm text-gray-500">{formatDate(booking.poojaFrom)}</p>
                                                                {booking.star && (
                                                                    <p className="text-sm text-gray-600">Star: {booking.star}</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span className="font-medium">₹{booking.poojaAmount}</span>
                                                </div>
                                                <div>
                                                    {booking.imageUrl && (
                                                        <IonImg src={booking.imageUrl}
                                                            onClick={() => {
                                                                setImage(booking.imageUrl)
                                                                setShowLightBox(true)
                                                            }} alt={booking.name || `Pooja ${booking.poojaCode}`} className="w-12 h-12 rounded-md object-cover" style={{ width: "150px", height: "150px" }} />
                                                    )}
                                                </div>
                                            </div>

                                            {booking.bookingSuccess === "7" && (
                                                <p className="text-red-500 text-sm mt-1">
                                                    Cancelled: {booking.templeBookingRemark}
                                                </p>
                                            )}
                                        </div>
                                    ))}
                            </div>
                        </IonCardContent>
                    </IonCard>

                    {/* Delivery and Payment Card */}
                    <IonCard>
                        <IonCardHeader>
                            <IonCardTitle>Delivery & Payment</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <div className="space-y-4">
                                {order.bookingDetailsDtos.some((b: any) => b.prasadamRequired === "1") && (
                                    <div className="border-b pb-3">
                                        <p className="font-medium">Delivery Address</p>
                                        <p className="text-sm text-gray-600 whitespace-pre-line">
                                            {order.bookingDetailsDtos.find((b: any) => b.prasadamDeliveryDetails)
                                                ?.prasadamDeliveryDetails}
                                        </p>
                                        <p className="text-sm mt-2">
                                            Delivery Charge: <span className="font-medium">₹{order.prasadamDeliveryCharge}</span>
                                        </p>
                                    </div>
                                )}

                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span>Pooja Amount : </span>
                                        <span>₹{order.poojaAmount}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span>Service Charges : </span>
                                        <span>₹{order.charges}</span>
                                    </div>
                                    {order.templeDonation > 0 && (
                                        <div className="flex justify-between">
                                            <span>Temple Donation : </span>
                                            <span>₹{order.templeDonation}</span>
                                        </div>
                                    )}
                                    {tantriCharges > 0 && (
                                        <div className="flex justify-between">
                                            <span>Tantri Charges : </span>
                                            <span>₹{tantriCharges}</span>
                                        </div>
                                    )}
                                    {poojari > 0 && (
                                        <div className="flex justify-between">
                                            <span>Poojari Dakshina : </span>
                                            <span>₹{poojari}</span>
                                        </div>
                                    )}
                                    {templeDonation > 0 && (
                                        <div className="flex justify-between">
                                            <span>Temple Donation : </span>
                                            <span>₹{templeDonation}</span>
                                        </div>
                                    )}
                                    <div className="flex justify-between font-bold pt-2 border-t">
                                        <span>Total Amount : </span>
                                        <span>₹{order.totalAmount}</span>
                                    </div>
                                </div>
                            </div>
                        </IonCardContent>
                    </IonCard>
                </div>
            </div>
        );
    };

    const modalClose = () => {
        window.location.reload();
    }

    const handleShare = (order: any) => {
        let shareText = ` Order Details:\n`;
        shareText += `Order No: ${order.orderNo}\n Date: ${formatDate(order.orderDate, "0")}\n\n`;

        shareText += `🔹 Pooja Details:\n`;
        order.bookingDetailsDtos.forEach((booking: any) => {
            shareText += ` ${booking.name || `Pooja ${booking.poojaCode}`}\n`;
            shareText += ` Date: ${formatDate(booking.poojaFrom, "1")}\n`;
            shareText += `Amount: ₹${booking.poojaAmount}\n\n`;
        });

        // Add Delivery Address if available
        const deliveryDetails = order.bookingDetailsDtos.find((b: any) => b.prasadamDeliveryDetails)?.prasadamDeliveryDetails;
        if (deliveryDetails) {
            shareText += ` Delivery Address:\n${deliveryDetails}\n\n`;
        }

        shareText += `💳 Total Amount: ₹${order.totalAmount}`;

        // Encode message properly
        const encodedMessage = encodeURIComponent(shareText);

        // Share via WhatsApp or Email
        const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
        const emailUrl = `mailto:?subject=Order Details&body=${encodedMessage}`;

        window.open(whatsappUrl, '_blank'); // Opens WhatsApp
        // window.open(emailUrl, '_blank'); // Uncomment for Email
    };

    // Fixed pagination component options with proper server-side configuration
    const paginationComponentOptions = {
        noRowsPerPage: false, // Enable rows per page selector
        rangeSeparatorText: 'of',
        selectAllRowsItem: false, // Disable select all for server-side pagination
        selectAllRowsItemText: 'All'
    };

    const subHeaderComponentdate = useMemo(() => {
        return (
            <IonRow className="table_btn_container">
                <div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <IonSearchbar
                        value={filterTextDate}
                        onIonChange={(e: any) => setFilterTextDate(e.target.value)}
                        placeholder="Search"
                        className="table_search"
                    />
                </div>
            </IonRow>
        );
    }, [filterTextDate]);

    const customTableStyle1 = {
        ...customTableStyle,
        headRow: {
            style: {
                borderWidth: "0px",
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                paddingLeft: '16px',
                paddingRight: '16px',
                border: "none",
                justifyContent: "left",
                textalign: "left",
                background: "#576f9f",
                color: "white"
            },
        },
        rows: {
            style: {
                borderWidth: "0.5px #E5E3E3",
            }
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "left",
                paddingLeft: '16px',
                paddingRight: '16px',
                paddingTop: '10px',
                paddingBottom: '10px',
                wordBreak: 'break-word',
                border: "none",
            }
        },
    }

    return (
        <IonPage>
            <IonContent>
                <HeadFoot User="login" Role="Role" Name="Home,User Booking Orders" />
                <IonLoading message="Loading..." spinner={null} isOpen={showLoading} />
                <div className="backgroundorders page_content_padding">
                    {showLoading === false && cartList.length === 0 ? (
                        <div style={{ height: "350px", width: "100%", display: "flex", justifyContent: "center" }}>
                            <IonText className="no_data">Your Order is Empty</IonText>
                        </div>
                    ) : (
                        <IonGrid>
                            {!isMobile ? (
                                <>
                                    <DataTable
                                        columns={headerColumns}
                                        data={dateTableData}
                                        expandableRows
                                        defaultSortFieldId="name"
                                        striped
                                        noDataComponent="Sorry! No result found"
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        paginationDefaultPage={currentPage + 1}
                                        paginationPerPage={rowsPerPage}
                                        paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                        onChangePage={handlePageChange}
                                        onChangeRowsPerPage={handleRowsPerPageChange}
                                        paginationComponent={CustomPaginationArrows}
                                        paginationComponentOptions={paginationComponentOptions}
                                        expandableRowsComponent={OrderDetailsCard}
                                        onRowClicked={handleRowClicks}
                                        expandableRowsHideExpander={false}
                                        subHeader
                                        subHeaderComponent={subHeaderComponentdate}
                                        selectableRows={false}
                                        customStyles={customTableStyle1}
                                    />
                                </>
                            )
                                :

                                //Changes
                                (
                                    <>

                                     <IonItem>
                                            <IonLabel>Items per page</IonLabel>
                                            <IonSelect
                                                value={rowsPerPage} // Bind to the current rowsPerPage state
                                                onIonChange={(e) => {
                                                    const newRows = e.detail.value;
                                                    // When rows per page changes, it's common to go back to the first page (page 1, or 0-indexed)
                                                    // You might adjust this logic based on your UX requirements.
                                                    handleRowsPerPageChange(newRows, 1); // Pass 1 for the first page (1-indexed)
                                                }}
                                            >
                                                <IonSelectOption value={5}>5</IonSelectOption>
                                                <IonSelectOption value={10}>10</IonSelectOption>
                                                <IonSelectOption value={20}>20</IonSelectOption>
                                                <IonSelectOption value={50}>50</IonSelectOption>
                                            </IonSelect>
                                        </IonItem>
                                        
                                        <div className="cart-list-parent">
                                            {cartList
                                                .slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage)
                                                .map((order: any) => (
                                                    <IonList key={order.orderNo} className="cart-list-item">
                                                        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", padding: "10px" }}>
                                                            <IonIcon onClick={() => handleShare(order)} icon={logoWhatsapp} />
                                                        </div>
                                                        <IonListHeader>
                                                            <IonLabel>
                                                                Order #{order.orderNo}
                                                                <IonText color="medium" className="ion-padding-start">
                                                                    {formatDate(order.orderDate, "0")}
                                                                </IonText>
                                                            </IonLabel>
                                                        </IonListHeader>

                                                        {order.bookingDetailsDtos
                                                            .filter((booking: any) => !['VDC', 'DLVR', 'TANTRI', 'SWAMI', 'TEMPLE'].includes(booking.poojaCode))
                                                            .map((booking: any) => (
                                                                <React.Fragment key={booking.id}>
                                                                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                                                        {booking.imageUrl && (
                                                                            <IonImg
                                                                                src={imagePathForRecipt + booking.imageUrl}
                                                                                onClick={() => {
                                                                                    setImage(imagePathForRecipt + booking.imageUrl);
                                                                                    setShowLightBox(true);
                                                                                }}
                                                                                alt={booking.name || `Pooja ${booking.poojaCode}`}
                                                                                className="w-12 h-12 rounded-md object-cover"
                                                                                style={{ width: "150px", height: "150px" }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                    <IonItem>
                                                                        <IonLabel>
                                                                            <h2>{booking.name || `Pooja ${booking.poojaCode}`}</h2>
                                                                            <IonText color="medium">{formatDate(booking.poojaFrom, "1")}</IonText>
                                                                            {booking.star && <IonNote>{booking.star}</IonNote>}
                                                                        </IonLabel>
                                                                        <IonText slot="end">₹{booking.poojaAmount}</IonText>
                                                                    </IonItem>
                                                                </React.Fragment>
                                                            ))}

                                                        {order.bookingDetailsDtos.some((b: any) => b.prasadamRequired === "1") && (
                                                            <IonItem>
                                                                <IonLabel className="ion-text-wrap">
                                                                    <h2>Delivery Address</h2>
                                                                    <p>
                                                                        {order.bookingDetailsDtos.find((b: any) => b.prasadamDeliveryDetails)?.prasadamDeliveryDetails}
                                                                    </p>
                                                                </IonLabel>
                                                                <IonText slot="end">₹{order.prasadamDeliveryCharge}</IonText>
                                                            </IonItem>
                                                        )}

                                                        <IonItem>
                                                            <IonLabel>Service Charge</IonLabel>
                                                            <IonText slot="end">₹{order.charges}</IonText>
                                                        </IonItem>

                                                        {order.bookingDetailsDtos
                                                            .filter((b: any) => ['TANTRI', 'TEMPLE', 'SWAMI'].includes(b.poojaCode))
                                                            .map((item: any) => (
                                                                <IonItem key={item.id}>
                                                                    <IonLabel>{item.name || `${item.poojaCode}`}</IonLabel>
                                                                    <IonText slot="end">₹{item.poojaAmount}</IonText>
                                                                </IonItem>
                                                            ))}

                                                        <IonItem lines="none">
                                                            <IonLabel>
                                                                <h2><strong>Total</strong></h2>
                                                            </IonLabel>
                                                            <IonBadge slot="end">₹{order.totalAmount}</IonBadge>
                                                        </IonItem>
                                                    </IonList>
                                                ))}
                                        </div>



                                       

{/*                             
                                        {cartList.length > rowsPerPage && 
                                        ( 
                                            <div className="mobile-pagination-container">
                                                <IonButton
                                                    fill="clear"
                                                    disabled={currentPage === 0}
                                                    onClick={() => handlePageChange(currentPage)} // Correct for previous button (1-indexed page)
                                                    className="pagination-button"
                                                >
                                                    <IonIcon
                                                        icon={chevronBack}
                                                        slot="icon-only"
                                                        color={currentPage === 0 ? "medium" : "primary"}
                                                    />
                                                </IonButton>

                                                <IonText className="page-indicator">
                                                    Page {currentPage + 1} of {totalPages}
                                                </IonText>

                                                <IonButton
                                                    fill="clear"
                                                    disabled={currentPage >= totalPages - 1}
                                                    onClick={() => handlePageChange(currentPage + 2)} // Correct for next button (1-indexed page)
                                                    className="pagination-button"
                                                >
                                                    <IonIcon
                                                        icon={chevronForward}
                                                        slot="icon-only"
                                                        color={currentPage >= totalPages - 1 ? "medium" : "primary"}
                                                    />
                                                </IonButton>
                                            </div>
                                        )
                                        } */}

                                    </>

                                )

                            }
                        </IonGrid>
                    )}
                </div>

                {showlightBox && (
                    <Lightbox
                        mainSrc={image}
                        onCloseRequest={() => setShowLightBox(false)}
                        onImageLoad={() => window.dispatchEvent(new Event('resize'))}
                    />
                )}

                <CommonModal showModal={Commonmodal} closeModal={modalClose} modaltitle={Commmonmodaltitle} AlertModalMesg={CommonModalMesg} />
                <Foot />
            </IonContent>
        </IonPage>
    );

}

export default UserBookingOrders;